import { render, staticRenderFns } from "./SectorPosts.vue?vue&type=template&id=64bb6a68&scoped=true"
import script from "./SectorPosts.vue?vue&type=script&lang=js"
export * from "./SectorPosts.vue?vue&type=script&lang=js"
import style0 from "./SectorPosts.vue?vue&type=style&index=0&id=64bb6a68&lang=scss&scoped=true"
import style1 from "./SectorPosts.vue?vue&type=style&index=1&id=64bb6a68&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bb6a68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64bb6a68')) {
      api.createRecord('64bb6a68', component.options)
    } else {
      api.reload('64bb6a68', component.options)
    }
    module.hot.accept("./SectorPosts.vue?vue&type=template&id=64bb6a68&scoped=true", function () {
      api.rerender('64bb6a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Tabs/SectorPosts.vue"
export default component.exports